
export default function(dom, opts) {
	let options = {
		textAreaSel: '.textarea',
		...opts
	};

	const textArea = dom.querySelector(options.textAreaSel);

		textArea.addEventListener('keyup', () => {
			adjustHeight(textArea);
		});

	function adjustHeight(e) {
		e.style.height = "1px";
		e.style.height = (25 + e.scrollHeight)+"px";
	}
}



